import React from 'react';
import {useHistory} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {I18n, Translate} from 'react-redux-i18n';
import * as snackbarsActions from '../../actions/snackbars';
import userService from '../../services/user/UserService';
import Snackbars from '../../layout/Snackbars';
import {pathResolver} from '../../utils/basePathHelper';

function UserActivationView() {
  const user = useSelector(state => state.user);
  const dispatch = useDispatch();
  const history = useHistory();
  if (!user) {
    return null;
  }

  if (user.emailVerified) {
    history.replace('/');
    return null;
  }

  const [submitting, setSubmitting] = React.useState(false);

  const handleResendEmail = () => {
    if (submitting) {
      return;
    }

    setSubmitting(true);

    userService.sendActivationEmail(user.id)
      .then(() => {
        dispatch(snackbarsActions.addSuccess(<Translate value="activateUser.emailSent"/>));
      })
      .catch(() => {
        dispatch(snackbarsActions.addError(<Translate value="error.generic"/>));
      })
      .finally(() => setSubmitting(false));
  };

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <>
      <Snackbars/>
      <div
        className="main-template background-white no-padding p-5"
        style={{height: '100vh'}}
      >
        <div className="row justify-content-center align-items-center h-100">
          {submitting && <div className="loading-overlay"/>}
          <div
            className="box emphasis flex-container column col-xl-6 col-lg-8 col-md-10 center space-between p-4"
            style={{minHeight: 450}}
          >
            <div className="flex-container center column success">
              <div style={{height: 200}}>
                <img
                  alt="activation email"
                  src={pathResolver('resources/svg/activation-email.svg')}
                  className="h-100"
                />
              </div>

              <h2
                className="m-0"
                style={{textAlign: 'center'}}
              >
                <strong>{I18n.t('activateUser.message', {email: user.email})}</strong>
              </h2>
            </div>

            <strong>
              <Translate value="activateUser.subMessage"/>
            </strong>

            <div>
              <div className="mb-4">
                <Translate value="activateUser.resendMessage"/>
                <span
                  data-id="resend-link"
                  className="clickable"
                  onClick={handleResendEmail}
                >
                  <Translate value="activateUser.button"/>
                </span>
              </div>

              <span>
                <Translate value="activateUser.messageLink"/>
                <span
                  data-id="reload-link"
                  className="clickable"
                  onClick={handleReload}
                >
                  <Translate value="activateUser.linkLabel"/>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UserActivationView;
